/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : Policies.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import CommonBreadcrumbs from "../../components/customComponentsV2/common/Breadcrumbs/CommonBreadcrumbs";
import AddButtonV2 from "../../components/customComponentsV2/common/button/AddButtonV2";
import CustomSearchbarWithApiV2 from "../../components/customComponentsV2/common/searchBar/CustomSearchbarWithApiV2";
import CustomDataGridV2 from "../../components/customComponentsV2/common/datagrid/CustomDataGridV2";

import BorderColorIcon from "@mui/icons-material/BorderColor";
import { useDispatch, useSelector } from "react-redux";
import { HandleApiActions, profileActions } from "../../redux/actions";
import policiesActions from "../../redux/actions/policiesActions";
import AddEditPolicies from "./policies/AddEditPolicies";
import CloseIcon from "@mui/icons-material/Close";
import CustomButtonV2 from "../../components/customComponentsV2/common/button/CustomButtonV2";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import CustomDialogBoxV2 from "../../components/customComponentsV2/common/customDialogBox/CustomDialogBoxV2";
import CustomFormTextFieldV3 from "../../components/customComponentsV2/common/textField/CustomFormTextFieldV3";

function Policies() {
  const dispatch = useDispatch();
  const policies = useSelector((state) => state.policyReducer.policies);
  const profileDetails = useSelector((store) => store.profileReducer);
  console.log("profileDetails", profileDetails);
  const [openAddEditPolicyDialog, setOpenAddEditPolicyDialog] = useState(false);
  const [openActionDetailsDialog, setOpenActionDetailsDialog] = useState(false);
  const [selectedPolicyActions, setSelectedPolicyActions] = useState(null);
  const [openAddEditPolicyDialogEdit, setOpenAddEditPolicyDialogEdit] =
    useState(false);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [policiesCount, setPoliciesCount] = useState("");
  const [openRollBackDialog, setOpenRollBackDialog] = useState(false);
  const [reason, setReason] = useState("");
  const [triggerGetPolicy, setTriggerGetPolicy] = useState(false);
  useEffect(() => {
    dispatch(HandleApiActions({ ...policiesActions.get_policies }));
  }, []);

  useEffect(() => {
    dispatch(HandleApiActions({ ...profileActions?.get_profile_details }));
  }, []);

  // const tableRowsData = useMemo(() => {
  //   return policies?.data?.policies?.map((data, idx) => ({
  //     id: (page - 1) * rowsPerPage + idx + 1,
  //     policy_key: data?.policyKey,
  //     name: data?.policyName,

  //     active_version: data?.activeVersion,
  //     effect: data?.effect,
  //     actions: data?.actions,
  //     umas_actions: data?.domains_actions?.flatMap((domain) => {
  //       return (domain?.actions || []).map((action) => ({
  //         id: `${domain.domain}_${action}`,
  //         code: action,
  //         name: `${domain.domain} : ${action}`,
  //       }));
  //     }),
  //     ...data,
  //   }));
  // }, [policies]);

  const mapDomainActions = (domains = []) => {
    return domains.flatMap((domain) =>
      (domain?.actions || []).map((action) => ({
        id: `${domain.domain}_${action}`,
        code: action,
        name: `${domain.domain} : ${action}`,
      })),
    );
  };

  const mapPolicyRow = (data, idx, page, rowsPerPage) => {
    return {
      id: (page - 1) * rowsPerPage + idx + 1,
      policy_key: data?.policyKey,
      name: data?.policyName,
      active_version: data?.activeVersion,
      effect: data?.effect,
      actions: data?.actions,
      umas_actions: mapDomainActions(data?.domains_actions),
      ...data,
    };
  };

  const tableRowsData = useMemo(() => {
    return policies?.data?.policies?.map((data, idx) =>
      mapPolicyRow(data, idx, page, rowsPerPage),
    );
  }, [policies, page, rowsPerPage]);

  console.log("policiesDetails", policies);

  const handleOpenActionDetailsDialog = (data) => {
    console.log("Action Details Data", data);
    setSelectedPolicyActions(data);
    setOpenActionDetailsDialog(true);
  };

  const handleTableRowClick = (data) => {
    console.log("---datadatadatadata----", data);
    setSelectedPolicyActions(data);
    setOpenAddEditPolicyDialogEdit(true);
  };

  const handleRollBackClick = (data) => {
    console.log("--data--datadata---", data);
    setSelectedPolicyActions(data);
    setOpenRollBackDialog(true);
  };

  const handleSuccessRollback = () => {
    let reqObj = {
      targetVersion: Number.parseInt(selectedPolicyActions?.row?.activeVersion) - 1,
      reason: reason,
    };
    console.log(" reqObj reqObj reqObj reqObj reqObj reqObj", reqObj);
    dispatch(
      HandleApiActions({
        ...policiesActions.delete_policies,
        api_name: `/UCM/policies/${selectedPolicyActions?.row?.policyKey}/rollback`,
        params: reqObj,
        show_toast: true,
      }),
    ).then(() => {
      setTriggerGetPolicy((prev) => !prev);
      setOpenRollBackDialog(false);
      setReason("");
    });
  };

  const handleCancelRollback = () => {
    setOpenRollBackDialog(false);
    setReason("");
  };

  const COLUMNS = [
    {
      field: "id",
      headerName: "S.No",
      flex: 0.4,
      minWidth: 60,
      maxWidth: 80,
      filterable: false,
      sortable: false,
    },
    // { field: "policy_key", headerName: "Policy Key", flex: 1, minWidth: 120 },
    {
      field: "name",
      headerName: "Policy Name",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <span
          style={{
            color: "#1e5e0aff",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: 500,
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleOpenActionDetailsDialog(params);
          }}
        >
          {params.value}
        </span>
      ),
    },

    { field: "active_version", headerName: "Active Version", width: 120 },

    {
      field: "effect",
      headerName: "Effect",
      width: 120,
      renderCell: (params) => {
        const value = params.value;
        console.log("paramsparams", params);

        return (
          <Chip
            sx={{ borderRadius: 0 }}
            label={value === "ALLOW" ? "Allow" : "Deny"}
            color={value === "ALLOW" ? "success" : "error"}
            size="small"
            variant="filled"
          />
        );
      },
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 0.4,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <IconButton
            size="small"
            sx={{ color: "#000000", p: 0.5 }}
            onClick={(e) => {
              e.stopPropagation();
              handleTableRowClick(params);
            }}
          >
            <BorderColorIcon fontSize="inherit" sx={{ fontSize: 19 }} />
          </IconButton>

          <IconButton
            disabled={Number.parseInt(params?.row?.active_version) > 1 ? false : true}
            size="small"
            sx={{ p: 0 }}
            onClick={(e) => {
              e.stopPropagation();
              handleRollBackClick(params);
            }}
          >
            {/* <img
              src={SettingsBackupRestoreIcon}
              alt="delete"
              style={{ width: 24, height: 24 }}
            /> */}
            <SettingsBackupRestoreIcon
              fontSize="inherit"
              sx={{
                fontSize: 19,
                color:
                  Number.parseInt(params?.row?.active_version) > 1 ? "black" : "grey",
              }}
            />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <div>
      <Box sx={{ p: 1 }}>
        {/*1. Breadcrumbs */}
        <Box>
          <CommonBreadcrumbs
            items={[
              { label: "Settings" },
              { label: "Accounts & Access" },
              { label: "Policies" },
            ]}
          />
        </Box>
        {/*2. Search Bar and Add Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
          }}
        >
          <Box>
            <CustomSearchbarWithApiV2
              apiAction={{ ...policiesActions.get_policies }}
              params={{ offset: page, limit: rowsPerPage }}
              searchKey="policyName"
              size="small"
              type="text"
              variant="outlined"
              placeholder="Search Policies..."
              valueError={""}
              triggerApi={triggerGetPolicy}
              isMultiline={false}
              minRows={1}
              maxRows={3}
              disabled={false}
              txtFldStyle={{
                width: "100%",
              }}
              onSearchQueryChange={(newQuery, oldQuery) => {
                console.log("---newQuery---", newQuery, oldQuery);
                if (newQuery !== oldQuery) {
                  setPage(1);
                }
              }}
              getDataOnSearch={(data, resp) => {
                console.log("Search datadata", data);
                setPoliciesCount(data?.meta?.total_count);
              }}
            />
          </Box>
          <Box sx={{ mt: 1, mb: 1 }}>
            <AddButtonV2
              handleOnClick={() => setOpenAddEditPolicyDialog(true)}
            />
          </Box>
        </Box>

        {/*3. Policies Table */}
        <Box
          sx={{
            height: "76vh",
            width: "100%",
            display: "flex",
            flexDirection: "column",

            mt: 1,
          }}
        >
          <CustomDataGridV2
            rows={tableRowsData}
            columns={COLUMNS}
            // onRowClick={handleTableRowClick}
            page={page}
            isMultiLine={true}
            rowsPerPage={rowsPerPage}
            totalItems={policiesCount}
            showPagination={policiesCount > 0 ? true : false}
            handlePageChange={(newPage) => setPage(newPage)}
          />
        </Box>
      </Box>
      {openAddEditPolicyDialog && (
        <AddEditPolicies
          open={openAddEditPolicyDialog}
          onClose={() => setOpenAddEditPolicyDialog(false)}
          title="Add Policy"
        />
      )}
      {openAddEditPolicyDialogEdit && (
        <AddEditPolicies
          open={openAddEditPolicyDialogEdit}
          onClose={() => setOpenAddEditPolicyDialogEdit(false)}
          setTriggerGetPolicy={setTriggerGetPolicy}
          title="Update Policy"
          selectedPolicyActions={selectedPolicyActions}
        />
      )}

      {openActionDetailsDialog && (
        <Dialog
          open={openActionDetailsDialog}
          onClose={() => setOpenActionDetailsDialog(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle
            sx={{
              position: "relative",
              textAlign: "center",
              borderBottom: "1px solid #e0e0e0",
              pb: 1,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Action Details
            </Typography>

            <IconButton
              onClick={() => setOpenActionDetailsDialog(false)}
              size="small"
              sx={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <>
              <p>
                <b>Policy Name:</b> {selectedPolicyActions?.row?.name}
              </p>

              <p>
                <b>Actions:</b>
                <Box
                  component="pre"
                  sx={{
                    backgroundColor: "#f4f4f4",
                    p: 1.5,
                    borderRadius: 1,
                    fontSize: "0.85rem",
                    fontFamily: "monospace",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    overflowX: "auto",
                    maxHeight: 300,
                  }}
                >
                  {selectedPolicyActions?.row?.domains_actions
                    ?.flatMap((domain) => domain?.actions || [])
                    .map((action, index) => (
                      <div key={index}>
                        {index + 1}. {action}
                      </div>
                    ))}
                </Box>
              </p>
            </>
          </DialogContent>

          <DialogActions
            sx={{
              borderTop: "1px solid #e0e0e0",
              pt: 1,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
            }}
          >
            <CustomButtonV2
              type="cancel"
              btnName="Cancel"
              handleOnClick={() => setOpenActionDetailsDialog(false)}
            />
          </DialogActions>
        </Dialog>
      )}

      {openRollBackDialog && (
        <CustomDialogBoxV2
          onDisabled={(reason?.trim()?.length || 0) <= 2}
          open={openRollBackDialog}
          onClose={() => {
            setOpenRollBackDialog(false);
            setReason("");
          }}
          title={"Reason"}
          onClickSuccess={handleSuccessRollback} // Close and open More menu
          onClickReject={handleCancelRollback}
          actionButtonStyle={"continuous"}
          successButtonName={"Rollback"}
          rejectButtonName={"Cancel"}
        >
          <Stack sx={{ width: "300px", ml: -1 }}>
            <CustomFormTextFieldV3
              // label="Policy Key"

              required
              type="text"
              fldType="text"
              value={reason}
              setValue={setReason}
              placeholder="Enter Reason*"
              // infoname="policy_key"
            />
          </Stack>
        </CustomDialogBoxV2>
      )}
    </div>
  );
}

export default Policies;
